<template>
  <ClientOnly>
    <div
      :class="[$style.wrapper, loadState !== 'ready' && $style.hidden]"
    >
      <div
        ref="widgetRef"
        class="trustpilot-widget"
        :data-locale="trustpilotLocale"
        :data-template-id="templateId"
        :data-businessunit-id="businessUnitId"
        :data-style-height="height"
        :data-style-width="width"
        :data-token="token"
      >
        <a :href="reviewUrl" target="_blank" rel="noopener">Trustpilot</a>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { TrustPilotLoadState } from '~/composables/useTrustPilotWidget';

const TRUSTPILOT_LOCALES: Record<string, string> = {
  en: 'en-US',
  ru: 'ru-RU',
  ua: 'uk-UA',
  es: 'es-ES',
  pt: 'pt-PT',
  zh: 'zh-CN',
};

const props = withDefaults(defineProps<{
  templateId?: string;
  businessUnitId?: string;
  token?: string;
  height?: string;
  width?: string;
  reviewUrl?: string;
  locale?: string;
}>(), {
  templateId: '56278e9abfbbba0bdcd568bc',
  businessUnitId: '68c2897d3a76cea38634361a',
  token: '79b2b7a8-18a9-4eb4-a68e-e0b0486aba1e',
  height: '52px',
  width: '100%',
  reviewUrl: 'https://www.trustpilot.com/review/0detect.com',
});

const emit = defineEmits<{
  'state-change': [state: TrustPilotLoadState];
}>();

const { locale } = useI18n();
const widgetRef = ref<HTMLElement | null>(null);
const { loadState, initWidget } = useTrustPilotWidget(widgetRef);

const trustpilotLocale = computed(
  () => props.locale ?? TRUSTPILOT_LOCALES[locale.value] ?? 'en-US',
);

watch(loadState, (state) => {
  emit('state-change', state);
}, { immediate: true });

useHead({
  script: [
    {
      key: 'trustpilot-bootstrap',
      src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
      type: 'text/javascript',
      async: true,
    },
  ],
});

defineExpose({
  loadState,
  initWidget,
});
</script>

<style lang="scss" module>
.wrapper {
  width: 100%;
  margin-top: 35px;
}

.hidden {
  visibility: hidden;
  height: 0;
  margin-top: 0;
  overflow: hidden;
}
</style>
